module.exports = {"620522100":"兴国镇","620522101":"莲花镇","620522102":"西川镇","620522103":"陇城镇","620522104":"郭嘉镇","620522105":"五营镇","620522106":"叶堡镇","620522107":"魏店镇","620522108":"安伏镇","620522109":"千户镇","620522110":"王尹镇","620522111":"兴丰镇","620522112":"中山镇","620522113":"刘坪镇","620522114":"王铺镇","620522115":"王窑镇","620522116":"云山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620522.json
// module id = 2910
// module chunks = 0